// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ku-6";
export var imgContainer = "_ku-3";
export var menuIcon = "_ku-5";
export var pillWrapper = "_ku-2";
export var pillsContainer = "_ku-1";
export var subscriptionCard = "_ku-0";
export var subscriptionLogo = "_ku-4";